import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ScatterAnimTypes} from "../enums/ScatterAnimTypes";
import {ScatterAnimationView} from "./ScatterAnimationView";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {RomanEmpireParsedGameData} from "../server/data/RomanEmpireParsedGameData";
import {RomanEmpireParsedInitData} from "../server/data/RomanEmpireParsedInitData";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {ISymbolPositions} from "../winpresentation/geniefeature/GenieFeatureController";

export class ScatterAnimationController {
    private _view: ScatterAnimationView;
    private _scatterCounter: number = 0;
    private _scatterPos: number[];
    private _isGenieFeatureTriggered: boolean = false;

    constructor() {
        this._view = new ScatterAnimationView();
        this.addEventListeners();
    }

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event: GameEvent) => this.hideScatterAnimation());
        EventHandler.addEventListener(this, SpinReelEvent.REEL_STOP_SPIN_BOUNCE_STARTED, (event: GameEvent) => this.onReelSpinStopAnimComplete(event.params[0].reelId));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    private onGameDataParsed(data: RomanEmpireParsedGameData) {
        this._scatterPos = data.scatterPositions || [];
        this._isGenieFeatureTriggered = data.isGenieFeatureTriggered;
    }

    private onInitDataParsed(data: RomanEmpireParsedInitData) {
        this._scatterPos = data.scatterPositions || [];
    }


    private onReelSpinStopAnimComplete(reelId: number) {
        if (this._isGenieFeatureTriggered) { // added this check to return from scatter anticipation if genie feature is triggered.
            return;
        }
        if (this._scatterPos[reelId] != -1) {
            this._scatterCounter++;
            this._scatterCounter == 2 && this._view.playScatterAnimation(this._scatterPos, ScatterAnimTypes.ANTICIPATION, reelId);
            this._scatterCounter > 2 && this._view.playScatterAnimation(this._scatterPos, ScatterAnimTypes.TRIGGER, reelId);
        }
        (this._scatterCounter < 3 && reelId === 4) && this.hideScatterAnimation();
    }

    public playScatterIdleAnimation(symPos: ISymbolPositions) {
        let scatterArr = [-1, -1, -1, -1, -1];
        scatterArr[symPos.reelId] = symPos.symbolId;
        this._view.playScatterAnimation(scatterArr, ScatterAnimTypes.IDLE, symPos.reelId);
    }

    public hideScatterAnimation(): void {
        this._scatterCounter = 0;
        this._view.resetScatterAnimation();
    }

    // private onReelStopSpinBounceStarted(reelInfo: { reelId: number }) {
    //     if (this._scatterPos[reelInfo.reelId] != -1) {
    //         this._scatterCounter++;
    //     }
    //     this._scatterCounter == 2 && this._view.playScatterAnimation(this._scatterPos, ScatterAnimTypes.ANTICIPATION, reelInfo.reelId);
    //     this._scatterCounter > 2 && this._view.playScatterAnimation(this._scatterPos, ScatterAnimTypes.TRIGGER, reelInfo.reelId);
    // }
}